import React from 'react';

import styles from './tooltip-module.css';

const Tooltip = (props) => {
  const style = {
    height: props.height,
    top: props.top,
    left: props.left,
  };

  if (props.content) {
    return (
      <span className={`${styles.toolTip} ${props.className || ''}`}>
        <span>{props.children}</span>
        <span className={`${styles.toolTipText}`} style={style}>{props.content}</span>
      </span>
    );
  }

  const renderToolTipIcon = () => {
    if (props.customIcon) {
      return <span className={`${styles.toolTipIcon}`}>
          {props.customIcon}
        </span>;
    }

    return <span className={`${styles.toolTipIcon}`} />
  }

  return (
    <div className={`${styles.toolTip} ${props.className || ''}`}>
      {renderToolTipIcon()}
      <span className={`${styles.toolTipText}`} style={style}>{props.children}</span>
    </div>
  );
};

export default Tooltip;
